import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Planning/addSeleccionPlanning`, method: 'POST', body: list, token: token})
}